"use strict";

function handleCallOfferSubmit(token, formId) {
  const form = document.querySelector("#".concat(formId));
  const formButton = form.querySelector("button");
  if (formButton.classList.contains("loading")) {
    return;
  }
  formButton.classList.add("loading");
  const formData = new FormData(form);
  const formProps = Object.fromEntries(formData);
  let invalid = false;
  ["name", "phone", "agree"].forEach(input => {
    if (!formProps[input]) {
      form.querySelector("[name=".concat(input, "]")).setAttribute("error", "");
      invalid = true;
    }
  });
  if (invalid) {
    formButton.classList.remove("loading");
    return;
  }
  fetch("".concat(settings.templateDir, "/post/call-offer.php"), {
    credentials: "same-origin",
    mode: "same-origin",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(formProps)
  }).then(resp => {
    if (resp.status === 200) {
      return resp.json();
    } else {
      form.querySelector(".result-text").innerText = "Kunne ikke udføre anmodningen. Ring venligst direkte til os i stedet.";
      form.classList.add("text-red-600");
      return Promise.reject("server");
    }
  }).then(() => {
    form.innerHTML = "\n      <div class=\"text-4xl font-extrabold\">Tak for din henvendelse!</div>\n      <div>Vi kontakter dig hurtigst muligt.</div>\n      ";
    form.classList.add("py-12");
  }).catch(err => {
    if (err === "server") return;
    console.log(err);
  });
}
function onCallOfferCheckboxChange(e) {
  e.target.removeAttribute("error");
}
function onCallOfferInputFocus(e) {
  e.target.removeAttribute("error");
}
//# sourceMappingURL=callOffer.js.map